export const SLACK_PATHS = {
  connect: "/slack/connect",
  install: "/slack/install",
  installComplete: "/slack/install/complete",
  workspace: "/slack/workspace",
} as const;

export const isSlackPath = (pathname: string) =>
  Object.values(SLACK_PATHS).some((path) => pathname.startsWith(path));
